// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let BroadcastSearchResultTimestamp = require("../BroadcastSearchResultTimestamp.bs.js");
let DevelopmentProjectSearchResultTimestamp_developmentProject_graphql = require("../../../__generated__/DevelopmentProjectSearchResultTimestamp_developmentProject_graphql.bs.js");

let convertFragment = DevelopmentProjectSearchResultTimestamp_developmentProject_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, DevelopmentProjectSearchResultTimestamp_developmentProject_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(DevelopmentProjectSearchResultTimestamp_developmentProject_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, DevelopmentProjectSearchResultTimestamp_developmentProject_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(DevelopmentProjectSearchResultTimestamp_developmentProject_graphql.node, convertFragment, fRef);
}

let ProjectFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function DevelopmentProjectSearchResultTimestamp(props) {
  let match = RescriptRelay_Fragment.useFragment(DevelopmentProjectSearchResultTimestamp_developmentProject_graphql.node, convertFragment, props.project);
  return JsxRuntime.jsx(BroadcastSearchResultTimestamp.make, {
    updatedAt: match.updatedAt,
    broadcastAt: match.broadcastAt
  });
}

let make = DevelopmentProjectSearchResultTimestamp;

exports.ProjectFragment = ProjectFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
